import lozad from 'lozad';
class LazyAsset {
    constructor() {
        let t = this;
        this.observer = lozad('.LazyAsset__item', {
            threshold: 0,
            loaded: function(el) {
                t.loadSingleImage( el );
                // el.classList.add('wrapper__item--loaded')
                // if( el.tagName.toLowerCase() == 'picture' && el.querySelector('source').hasAttribute('data-srcset') ) {
                //     el.querySelector('img').removeAttribute('src');
                //     el.querySelector('source').setAttribute('srcset', el.querySelector('source').getAttribute('data-srcset') );
                // }
            }
        });
    }
    init() {
        let t = this;
        if(document.readyState === 'complete') {
            t.loadImage();
        }
        else {
            document.addEventListener('readystatechange', function(e) {
                if( e.target.readyState === 'complete' ) {
                    t.loadImage();
                }
            });
        }

        //zacznij ładować poniższe zdjęcia zaraz po zaladowaniu się podstawowej wersji strony
        window.addEventListener('load', function () {
            document.querySelectorAll('.LazyAsset__item.wrapper__item--ar').forEach( function( image, index ) {
                t.observer.triggerLoad( image );
            });
        });

    }
    loadSingleImage( image = null /* .LazyAsset__item */ ) {
        if( image ) {
            image.classList.add('wrapper__item--loaded');
            if( image.tagName.toLowerCase() == 'picture' && image.querySelector('source').hasAttribute('data-srcset') ) {
                image.querySelector('img').removeAttribute('src');

                if( window.theme.webp ) {
                    image.querySelector('source').setAttribute('srcset', image.querySelector('source').getAttribute('data-srcset') );
                } else { // set into source srcset jpg image
                    image.querySelector('source').setAttribute('srcset', image.querySelector('source').getAttribute('data-srcset-basic') );
                }

                image.querySelector('source').removeAttribute('data-srcset-basic');
                
            }
        }
    }
    loadImage() {
        let t = this;
        t.observer.observe();
    }
}
export default LazyAsset;